var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('grid-view',{attrs:{"api-url":`home/logs/${_vm.dbTable}/${_vm.itemId}`,"use-filter":"","small":"","fields":_vm.table.fields,"default-sort":_vm.table.sort,"default-reverse":_vm.table.reverse,"default-per-page":_vm.table.itemsPerPage,"collection-description":"change log","item-name":"log"}},[_c('back-button')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }